export default {
  selectMenu: {
    height: 56,
  },
  outlined: {
    display: 'flex',
    alignItems: 'center',
  },
};
